<template>
  <div class="card overflow-hidden">
    <div class="bg-soft-primary">
      <div class="row">
        <div class="col-7">
          <div class="text-primary p-3">
            <h5 class="text-primary">Welcome Back !</h5>
            <!-- <p>Admin Dashboard</p> -->
          </div>
        </div>
        <div class="col-5 align-self-end">
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
        </div>
      </div>
    </div>

    <div class="card-body pt-0">
      <div class="row">
        <div class="col-sm-4  mb-3">
          <div class="avatar-md profile-user-wid mb-4">
            <b-dropdown
              toggle-class="nav-btn"
              menu-class="dropdown-menu-end"
              left
              variant="white"
            >
              <template v-slot:button-content>
                <img
                  v-if="
                    GET_USER_INFO !== null &&
                      GET_USER_INFO.photo !== undefined &&
                      GET_USER_INFO.photo !== null
                  "
                  :src="GET_USER_INFO.photo"
                  alt
                  class="avatar-lg rounded-circle"
                />
                <div
                  v-else
                  class="rounded-circle"
                  style="width: 70px; height: 70px; background-color: #f8f8fb; "
                >
                  <i
                    class="bx bx-user"
                    style="font-size: 40px; margin-top: 15px; "
                  ></i>
                </div>
              </template>
              <b-dropdown-item @click="onChangeProfilePictureClick"
                >Change profile picture</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <!-- <h5 class="font-size-15 text-truncate">{{ userInfo.name_en }}</h5>
          <p class="text-muted mb-0 text-truncate">
            {{ userInfo.departmentname }}
          </p> -->
        </div>

        <div class="col-sm-8" v-if="userInfo.type === 'Vendor'">
          <div class="pt-4">
            <div class="row">
              <div class="col-12">
                <p class="text-muted mb-0" style="text-align: center">
                  จำนวนผู้ขายที่ดูแลอยู่ 
                </p>

                <h5 class="font-size-15" style="text-align: center">
                  {{ userInfo.vendors.length }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3" v-if="userInfo.type === 'Vendor'">
        <div class="col-sm-12">
          <h5 class="font-size-22 text-truncate">
            {{ userInfo.first_name.th }} {{ userInfo.last_name.th }}
          </h5>
        </div>
      </div> -->
      <div
        class="row"
        v-if="
          userInfo.first_name !== undefined && userInfo.last_name !== undefined
        "
      >
        <div class="col-sm-12">
          <h5 class="font-size-22 text-truncate">
            {{ userInfo.first_name.th }} {{ userInfo.last_name.th }}
          </h5>
        </div>
      </div>

      <div class="row mt-2 mt-1">
        <div class="col-sm-12">
          <span class="font-size-14"
            ><b class="font-size-14">อีเมล: </b>
            {{ userInfo.email }}
          </span>
        </div>
      </div>

      <div v-if="userInfo.type === 'Operator' && userInfo !== undefined">
        <div class="row mt-1">
          <div class="col-sm-12">
            <span class="font-size-14"
              ><b class="font-size-14">รหัสพนักงาน: </b>
              {{ userInfo.user_operator.employee_info.crc_id }}
            </span>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-sm-12">
            <span class="font-size-14"
              ><b class="font-size-14">แผนก: </b>

              {{ userInfo.user_operator.employee_info.department_name }}
            </span>
          </div>
        </div>
      </div>
      <div v-else-if="userInfo !== undefined">
        <div class="row mt-1">
          <div class="col-sm-12">
            <span class="font-size-14"
              ><b class="font-size-14">รหัสผู้ขาย: </b>
              {{ GET_VENDOR_SELECTED.code }}
            </span>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-sm-12">
            <span class="font-size-14"
              ><b class="font-size-14">ชื่อผู้ขาย: </b>
              {{ GET_VENDOR_SELECTED.name }}
            </span>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-sm-12">
          <span class="font-size-14"
            ><b class="font-size-14">ประเภทผู้ใช้งาน: </b>
            {{ userInfo.type }}
          </span>
        </div>
      </div>
    </div>

    <!-- end card-body -->
    <ChangeProfilePictureModalComponent :user_id="userInfo.id" />
  </div>
  <!-- end card -->
</template>
<script>
import ChangeProfilePictureModalComponent from '@/components/share/modal-change-profile-pic'
import { authComputed } from '@/state/helpers'

export default {
  props: {
    userInfo: { type: Object, default: Object },
    userOAuth: { type: Object, default: Object },
  },
  components: {
    ChangeProfilePictureModalComponent,
  },
  computed: {
    ...authComputed,
  },
  methods: {
    onChangeProfilePictureClick() {
      this.$bvModal.show('modal-change-profile-pic')
    },
  },
}
</script>
